module.exports = __webpack_public_path__ + "static/media/3.db646f58.jpg";